import {
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Typography,
  Alert,
} from '@mui/material';
import React, { useContext, useState } from 'react';
import { Workflow } from '../../../enums/orders';
import { DriverOrdersAccounting } from './invoices/driver_accounting';
import MerchantOrdersAccounting from './invoices/merchant-orders-accounting';
import BranchTransfers from './invoices/branch-transfers';
import { useSearchParams } from 'react-router-dom';
import TabsLayout from '../../common/tabs-layout/tabs-layout';
import Expenses from './expenses/expenses';
import RecurringExpenses from './recurring-expenses/recurring-expenses';
import CashFlow from './cash-flow/cash-flow';
import { AuthContext } from '../../../contexts/user-context/user-context';
import { GlobalPermissions, Page, user_has_global_permission, user_has_page_access, user_is_admin } from '../../../utils/permissions';
import { Wallet } from './wallet';

function Accounting() {
  const { user } = useContext(AuthContext)
  return (
    <>
      <Typography
        variant="h3"
        component="h3"
        sx={{ textAlign: 'center', mt: 1 }}
      >
        Accounting
      </Typography>

      <TabsLayout
        orientation="horizontal"
        source="main-accounting"
        sections={[
          {
            label: 'Wallet',
            content: <Wallet />
          },
          {
            label: 'Cash Flow',
            content: <CashFlow />,
            disabled: !user_has_global_permission(user, GlobalPermissions.ACCESS_CASH_FLOW)
          },
          {
            label: 'Expenses',
            content: <Expenses />,
            disabled: !user_has_page_access(user, Page.EXPENSES),
          },
          {
            label: 'Recurring Payments',
            content: <RecurringExpenses />,
            disabled: !user_has_page_access(user, Page.RECURRING_PAYMENTS)
          },
          {
            label: 'Driver Invoices',
            content: <DriverOrdersAccounting />,
            disabled: !user_has_page_access(user, Page.DRIVER_INVOICES),
          },
          {
            label: 'Merchant Invoices',
            content: <MerchantOrdersAccounting />,
            disabled: !user_has_page_access(user, Page.MERCHANT_INVOICES),
          },
          {
            label: 'Branch Transfers',
            content: <BranchTransfers />,
            disabled: !user_has_page_access(user, Page.MERCHANT_INVOICES),
          },
        ]}
      />
    </>
  );
}

export default Accounting;
